import React, { useState, useEffect } from "react";
import SecurityLogo from "../../assets/png/security-info.png";
import CommonModal from "../Modals/CommonModal";
import SecurityIcon from "../../assets/png/security.png";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";

const TwofaDisableDrawer = ({ userEmail }) => {
  const [modalShow, setModalShow] = useState(false);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const navigate = useNavigate();
  useEffect(() => {
    if (modalShow) {
      setTimeout(function () {
        setModalShow(false);
        document.getElementById("closeDrawer").click();
      }, 1000);
    }
  }, [modalShow]);

  useEffect(() => {
    if (modalShow) {
      setTimeout(function () {
        navigate("/account", { dep: 1 });
        setModalShow(false);
      }, 2000);
    }
  }, [modalShow]);

  const reqDisable = async () => {
    try {
      const disbale = await servicePost(
        "api/v1/admin/admindisabletwofa",
        {
          user: userEmail,
        },
        notification,
        authToken
      );

      if (disbale.message == "SUCCESS") {
        setModalShow(true);
      }
    } catch (error) {
      console.log("err".error);
    }
  };

  return (
    <>
      <CommonModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="Two-Factor Authentication Disabled successfully"
      />
      <div className="active-acc-drawer-wrapper">
        <span
          id="closeDrawer"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></span>
        <div className="twofa-disable-drawer-wrapper">
          <div className="twofa-disable-drawer-wrap">
            <div className="twofa-status-drawer-wrapper">
              <img src="./images/twofa-enable.png" alt="icon" />
              <p className="twofa-status"> Status</p>
              <h2> ENABLED</h2>

              {/* <div className="disable-twofa-input-wrap">
                <input
                  type="checkbox"
                  id="switch"
                  checked={isChecked}
                  onChange={toggleChecked}
                />
                <label for="switch">Toggle</label>
                <p> Disable 2FA</p>
              </div> */}
            </div>
          </div>
          <div className="principle-security">
            <img src={SecurityIcon} alt="icon" />
            <p>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr sed diam
              nonumy eirmod tempor invidunt ut
            </p>
          </div>

          <div className="confirm-button-wrapper">
            <div className="confirm-button-wrap">
              <>
                <button onClick={reqDisable}>Confirm</button>
                <button
                  className="cancel-button"
                  id="closeDrawer"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwofaDisableDrawer;
